import React, {useState} from 'react';
import Modal from '../Modal';

const IncorrectLocationDialog = (props) => {
 return <Modal open={props.open} setOpen={props.setOpen} text={props.dialogText} title="Je bent er bijna!"/>
}

export default IncorrectLocationDialog;
